import React from "react";

export default function Networks() {
  return (
    <>
      <div className="networks">
        <a
          className="networks-links"
          href="https://www.linkedin.com/in/thomas-chalanson/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            src="https://cdn-icons-png.flaticon.com/512/174/174857.png"
            className="networks-logos"
            alt="logo"
          />
        </a>

        <a
          className="networks-links"
          href="https://github.com/thomas37000"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            src="https://github.githubassets.com/images/modules/logos_page/Octocat.png"
            className="networks-logos"
            alt="Github logo"
          />
        </a>

        <a
          className="networks-links"
          href="https://codepen.io/thomaschalanson"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            src="https://blog.codepen.io/wp-content/uploads/2012/06/Button-Fill-White-Large.png"
            className="networks-logos"
            alt="logo"
          />
        </a>

        <a
          className="networks-links"
          href="https://codesandbox.io/u/thomas37000"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            src="https://ci.codesandbox.io/static/favicon.ico"
            className="networks-logos"
            alt="logo"
          />
        </a>
      </div>
    </>
  );
}
